import React, { Component } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import { get } from 'lodash';

export default class RowItemDSQuanLyHoSo extends Component {
  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{
          <Link to={'/quan-ly-ho-so/danh-sach-ho-so/' + get(this.props.item, 'cuocThanhTra.id')} className='txt-underline txt-blue'>{
            get(this.props.item, 'maHoSo') || ''
          }</Link>
        }</td>
        <td>{get(this.props.item, 'nguoiLuu.hoVaTen') || ''}</td>
        <td>{get(this.props.item, 'cuocThanhTra.tenDonVi') || ''}</td>
        <td>{get(this.props.item, 'createdDate') ? moment(get(this.props.item, 'createdDate')).format('DD/MM/YYYY') : ''}</td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/quan-ly-ho-so/datatable/RowItemDSQuanLyHoSo.jsx